import { getJson, putJson } from "../../../../lib/api-client";

const BASE = "/api/v1/admin/web3/hyperliquid/fills";
const FEES = "/api/v1/admin/web3/hyperliquid/fees";

function cleanParams(obj) {
  const out = {};
  for (const [k, v] of Object.entries(obj)) {
    if (v === undefined || v === null || v === "") continue;
    out[k] = v;
  }
  return out;
}

export function fetchFillsStats(params) {
  return getJson(`${BASE}/stats`, cleanParams({ ...params }));
}

export function fetchFillsUsers(params) {
  return getJson(`${BASE}/users`, cleanParams({ ...params }));
}

export function fetchFillsList(params) {
  return getJson(BASE, cleanParams({ ...params }));
}

// Builder fees — returns [{ key: "perp"|"copy", feeInt }]
export function fetchFees() {
  return getJson(FEES);
}

// feeInt: integer 0..100 (tenths of a basis point; 100 = 0.1%)
export function updateFee(key, feeInt) {
  return putJson(`${FEES}/${key}`, { feeInt });
}
